import type { EhrModulesAndTilesResponse } from "../../types/general/EhrModulesAndTilesResponse";

import Repository from "./Repository";

export const moduleRepository = {
  async ehrModulesAndTiles(): Promise<EhrModulesAndTilesResponse> {
    const response = await Repository.post<EhrModulesAndTilesResponse>("home/ehrmodulesandtiles");
    return response.data;
  },
};
